export default "__VITE_ASSET__DbgXeKMr__"